import { Locales } from './locales'

import en from './en.json'
import de from './de.json'
import se from './se.json'
import pl from './pl.json'
import pt from './pt.json'
import ru from './ru.json'
import it from './it.json'
import cs from './cs.json'
import fr from './fr.json'
import es from './es.json'

export const noLangDefined = {}

export const messages = {
  [Locales.EN]: en,
  [Locales.SE]: se,
  [Locales.DE]: de,
  [Locales.NO]: noLangDefined,
  [Locales.FI]: noLangDefined,
  [Locales.FR]: fr,
  [Locales.PL]: pl,
  [Locales.NL]: noLangDefined,
  [Locales.IT]: it,
  [Locales.ES]: es,
  [Locales.HU]: noLangDefined,
  [Locales.PT]: pt,
  [Locales.RU]: ru,
  [Locales.JA]: noLangDefined,
  [Locales.TH]: noLangDefined,
  [Locales.ID]: noLangDefined,
  [Locales.CS]: cs,
}

export const defaultLocale = Locales.EN

